'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { isResolved, isLoading, isError } from 'reference-resolvers/utils';
import ResolveReferences from 'reference-resolvers/ResolveReferences';
import { DEAL_PIPELINE_STAGE } from 'reference-resolvers/constants/ReferenceObjectTypes';
import ErrorMessage from 'reporting-ui-components/components/shared/ErrorMessage';
import getErrorTypeFromException from 'reporting-data/lib/getErrorTypeFromException';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
export const provideDealStage = ResolveReferences(({
  [DEAL_PIPELINE_STAGE]: resolver
}, {
  stageId
}) => ({
  dealStage: resolver.byId(stageId)
}));
export const DealStageName = provideDealStage(({
  dealStage,
  showPipelineLabel
}) => {
  if (isError(dealStage)) {
    const error = dealStage.reason;
    return /*#__PURE__*/_jsx(ErrorMessage, {
      type: getErrorTypeFromException(error),
      error: error
    });
  }
  if (isLoading(dealStage)) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true
    });
  }
  if (!isResolved(dealStage)) {
    return null;
  }
  const dealStageName = dealStage.referencedObject.get('label');
  const pipelineName = dealStage.referencedObject.getIn(['pipeline', 'label']);
  return /*#__PURE__*/_jsx("span", {
    children: showPipelineLabel ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'reporting-ui-components.customWidgets.forecastWidget.nameWithPipeline',
      options: {
        dealStageName,
        pipelineName
      }
    }) : dealStageName
  });
});
DealStageName.propTypes = {
  stageId: PropTypes.string.isRequired,
  showPipelineLabel: PropTypes.bool
};